import React, { useState, useEffect } from "react";
import global from "../../global-variables";
import Header from "../layout/header";
import { Link, useNavigate } from "react-router-dom";
import $ from "jquery";
import WOW from "wowjs";

import { Container, Row, Col } from "reactstrap";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Metatag from "../../hooks/Metatag";
import globalVariables from "../../global-variables";
import mixitup from 'mixitup';
import { HashLink } from "react-router-hash-link";
import { GetPartnerCategoryList, GetPartnerList } from '../../api/partner-functions';


export default function Partners() {
  const [show, setShow] = useState(false);

  const navigate = useNavigate();

  const scrollWithOffset = (el) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -134;
    window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
  }


  useEffect(() => {

    $(window).on("scroll", function () {
      $(".navbar").offset().top > 10 ? $(".fixed-top").removeClass("bg-header-home") : $(".fixed-top").removeClass("bg-header-home")
    });



  }, []);

  const [partner, setPartnerList] = useState([]);

  const [partnerCategory, setPartnerCategoryList] = useState([]);


  // success function when the list is retrived
  const OnGetPartnerSuccess = (p_response) => {

    // set the list for looping
    setPartnerList(p_response);
  }
  const OnGetPartnerCategorySuccess = (p_response) => {
    // set the list for looping
    setPartnerCategoryList(p_response);

    let _objPartners = new Object();
    _objPartners.partner_status = 1;

    // call the function to get the partners
    GetPartnerList(_objPartners, OnGetPartnerSuccess, navigate);

  }
  // things to be done when the page is loaded
  useEffect(() => {

    //make the object for getting the list
    let _objPatnerCat = new Object();

    // call the function to get the  list
    GetPartnerCategoryList(_objPatnerCat, OnGetPartnerCategorySuccess, navigate)

  }, []);


  useEffect(() => {

    // initiate the wow effect
    new WOW.WOW({
      live: false,
    }).init();

    var containerEl = document.querySelector('.container-mix');

    var mixer = mixitup(containerEl);

    // Cleanup when the component is unmounted
    return () => {
      mixer.destroy();
    };


  }, [partner])

  return (
    <>
      <Header></Header >

      <Metatag title='Green Energy and Sustainability Research Partnerships by IIT Bombay'
        description='Green Energy and Sustainability Research Partnerships by IIT Bombay'
        keywords="Green Energy and Sustainability Research Partnerships by IIT Bombay"
      />
      {/* Visual Panel */}
      <Container fluid className="bg-visual-inside px-0" >
        <div className="visual-inside-big visual-container-inside">
          <Container>
            <Row className="g-md-0">
              <Col md={12}>
                <div className="py-md-4">
                  <div className="m-0 text-center py-xl-3 p-2 text-white">
                    <h1 className="fw-light text-white m-0 align-self-center wow fadeInUp">
                      Partnerships
                    </h1>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </Container>


      {/* Container */}

      <Container className="my-5 pt-md-5 pt-4">
        <div className="bg-outreach rounded-4 position-relative overflow-hidden wow fadeInUp">
          <Row className="g-0 bg-black bg-opacity-50 p-md-5 p-4">
            <Col md={12} lg={12}>
              <div className="p-md-4 p-3 wow fadeInUp">
                <h2 className="text-center h1 fw-light lh-base text-white m-0 wow fadeInUp">
                  Begin your journey to contribute <br className="d-md-block d-none" />to a sustainable future by partnering with us
                </h2>
              </div>
            </Col>
          </Row>
        </div>
      </Container>


      <Container className="my-md-5 my-4">
        <Row className="g-0">

          <Col md={8} lg={12}>
            <div className="border rounded-4 px-lg-5 p-4 py-lg-5 h-100">
              <div className="pe-md-2 col-md-10 list mx-auto text-center">
                <p className="wow fadeInUp">GESH IITB invites sustainability leaders, innovators, and enthusiasts to collaborate with us in driving impactful change. At GESH IITB, we act as a bridge for advancing IIT Bombay's sustainability-focused research, education, training, events, talent development, and policy support.</p>
                <p className="wow fadeInUp">Partnering with GESH IIT Bombay offers a unique opportunity to tap into an extensive database of cutting-edge research projects and connect with expert faculty teams across diverse domains. Additionally, you gain direct access to India’s brightest student talent—future leaders and changemakers in the field of sustainability.</p>
                <HashLink to="#contact" className="btn btn-primary rounded-pill px-4 py-2 mt-3 wow fadeInUp" scroll={el => scrollWithOffset(el)}>Reach out to us</HashLink>
              </div>
            </div>
          </Col>
          {/* <Col md={5} lg={5} className="py-5 container-end">
            <div className="ps-lg-5 ps-md-4 bg-white h-100">
              <div className="border-bottom border-4 border-primary rounded-4 h-100">
                <div className="bg-primary bg-opacity-10 rounded-4 py-4 px-4 border h-100 list">
                  <p className="mb-4 lh-base wow fadeInUp">Curious to explore IIT Bombay’s cutting-edge sustainability research and state-of-the-art facilities? Or would you like to host IIT Bombay's expert faculty and talented students at your organization?</p>
                  <p className="mb-4 lh-base wow fadeInUp">GESH IIT Bombay facilitates insightful industry visits - both to and from IIT Bombay-to uncover opportunities for meaningful collaboration.</p>
                  <Link to="" className="btn btn-primary rounded-pill px-4 py-2 mt-3 wow fadeInUp">Reach out to us</Link>
                </div>
              </div>
            </div>
          </Col> */}
        </Row>
      </Container >

      {/* <Container className="my-5">
        <Row className="g-0">
          <Col md={12} lg={12}>
            <div className=" border rounded-4 p-4">
              <Container>
                <Row className="mb-5">
                  <Col md={8} xl={8}>

                  </Col>
                  <Col md={4} xl={4}></Col>
                </Row>
              </Container>
            </div>
          </Col>
        </Row>
      </Container> */}

      {/* Partners */}
      <Container className="my-md-5 my-4 d-none">

        <div>
          <Container>
            <h2 className="h1 text-center mb-3 fw-light text-primary wow fadeInUp">Partners</h2>
            <div className="d-flex flex-wrap gap-2 justify-content-center mb-5">
              <button type="button" className="btn btn-outline-primary rounded-pill px-4 wow fadeInUp control mixitup-control-active" data-filter="all">All</button>
              {
                partnerCategory.map((pcat, index) => {
                  return (

                    <button key={index} type="button" className="btn btn-outline-primary rounded-pill px-4 wow fadeInUp control" data-filter={`.prt-${pcat.prt_cat_id}`}>{pcat.prt_cat_name}</button>
                  )
                })
              }
            </div>
            <Row className="row-cols-2 row-cols-md-5 row-cols-lg-6 g-3 container-mix justify-content-center">
              {
                partner.map((partner, index) => {

                  return (
                    <Col key={index} className={`text-center mix prt-${partner.partner_prt_cat_id}`}>
                      <div className="px-3 border rounded-3 h-100">
                        {
                          partner.partner_website != "" ?
                            <Link to={partner.partner_website} target="_blank" rel="noreferrer">
                              <div className="px-4">
                                <img src={global.variables.strApiUrl + "/partner/" + partner.partner_logo} alt={partner.partner_name} title={partner.partner_name} className="img-fluid" />
                              </div>
                            </Link>
                            :
                            // <Link to="">
                            <div className="px-4">
                              <img src={global.variables.strApiUrl + "/partner/" + partner.partner_logo} alt={partner.partner_name} title={partner.partner_name} className="img-fluid" />
                            </div>
                          // </Link>
                        }
                      </div>
                    </Col>
                  )
                })
              }
            </Row>
          </Container>
        </div>

      </Container>
      {/* Partners */}
      <Container className="my-md-5 my-4">
        <Row className="g-0">
          <Col md={12} lg={12}>
            <div className="bg-light-green rounded-4 p-md-5 p-4">
              <div className="col-md-9 mx-auto text-center">
                <h6 className="mb-4 lh-base wow fadeInUp">Curious to explore IIT Bombay’s cutting-edge sustainability research and state-of-the-art facilities? Or would you like to host IIT Bombay's expert faculty and talented students at your organization?</h6>
                <h6 className="mb-4 lh-base wow fadeInUp">GESH IIT Bombay facilitates insightful industry visits - both to and from IIT Bombay-to uncover opportunities for meaningful collaboration.</h6>
                <HashLink to="#contact" className="btn btn-primary rounded-pill px-4 py-2 mt-3 wow fadeInUp" scroll={el => scrollWithOffset(el)}>Reach out to us</HashLink>
              </div>
            </div>
          </Col>
        </Row>
      </Container >


      {/* Breadcrumb */}
      <Breadcrumb className="breadcrumb-panel mt-auto">
        <Breadcrumb.Item href={globalVariables.variables.strDomainUrl}>Home</Breadcrumb.Item>
        <Breadcrumb.Item active>Partnership Opportunities</Breadcrumb.Item>
      </Breadcrumb>
    </>
  );
}